
import MyLoading from './loading.vue';
const Loading = {
  install: function(Vue){
    Vue.component('Loading',MyLoading)
  }
}
// 导出组件
export default Loading



// WEBPACK FOOTER //
// ./src/components/common/loading/index.js